import { OutcropExamples } from '~/components/wiki/OutcropExamples';
import { useGeologyWikiDetailOutletContext } from '~/routes/wiki/geology/$wikiId';

export default function GeologyWikiExamplesRoute() {
  const { wikiPage } = useGeologyWikiDetailOutletContext();

  return <OutcropExamples parentType="depositionalWiki" parent={wikiPage} />;
}
